const PREMIUM = {
    UPDATE_WIDGET_PREMIUM_AND_TRIAL: 'UPDATE_WIDGET_PREMIUM_AND_TRIAL',
    UPDATE_WIDGET_SOME_PREMIUM_PARAMS: 'UPDATE_WIDGET_SOME_PREMIUM_PARAMS',
}

export {PREMIUM}